export const PB_BASE = ''

export const fmtDate = (value) =>
  new Intl.DateTimeFormat('ru-RU', {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(value))

export const fmtPercent = (value) => `${Math.round((value || 0) * 100)}%`
export const randomForce = () => Math.floor(Math.random() * (300 - 50 + 1)) + 50;
export const randomBpm = () => Math.floor(Math.random() * (100 - 60 + 1)) + 60;


export const getMusicFileUrl = (music) => {
  if (!music?.id || !music?.file) return null
  return `${PB_BASE}/api/files/music/${music.id}/${music.file}`
}

export const getWorkoutTitle = (record) => {
  if (!record) return 'Unknown workout'
  return record.title || record.name || record?.expand?.musicId?.title || 'Unknown workout'
}


export function unixTimestampsFromStartTime(timestamps, startTime) {
  let result = []
  if (!timestamps) return result;

  timestamps.forEach(timestamp => {
    result.push((timestamp - startTime) / 1000)
  });

  return result
}

export function mapPunchesToTargets(punches, targets) {
  if (!punches || !targets || targets.length === 0) return {};

  const targetMap = {};
  targets.forEach(t => { targetMap[t] = null; });

  for (const punchTime of punches) {
    let closestTarget = null;
    let minDiff = Infinity;

    for (const targetTime of targets) {
      const diff = Math.abs(punchTime - targetTime);
      if (diff < minDiff) {
        minDiff = diff;
        closestTarget = targetTime;
      }
    }

    if (closestTarget !== null) {
      const existing = targetMap[closestTarget];
      if (existing === null || minDiff < Math.abs(existing - closestTarget)) {
        targetMap[closestTarget] = punchTime;
      }
    }
  }

  // console.log("mapPunchesToTargets:", punches, targets, targetMap)

  return targetMap;
}

export function computeStats(targetMap, targets, punches) {
  // console.log("<computeStats>")
  const totalTargets = targets.length;
  const occupiedTimestamps = Object.values(targetMap).filter((v) => v !== null).length;
  const totalHits = punches.length;

  let totalDelay = 0;
  let count = 0;

  for (const targetTime of targets) {
    const punchTime = targetMap[targetTime];
    if (punchTime !== null) {
      totalDelay += Math.abs(punchTime - targetTime);
      count++;
    }
  }

  const avgDelay = count > 0 ? totalDelay / count : 0;
  const efficiency = totalHits > 0 ? occupiedTimestamps / totalHits * 100 : 0;

  return {
    avgDelay,
    efficiency: isNaN(efficiency) ? 0 : efficiency,
    hitTargets: occupiedTimestamps,
    totalTargets,
  };
}

function syncTimeWithServer() {
  const berforeTimesync = Date.now()
  fetch()
  const afterTimesync = Date.now()
}

export function enrichWorkout(workout, workoutTemplates) {
  const template = workoutTemplates.find((w) => w.id === workout.templateId);

  if (!workout.punches || !template) {
    return {
      ...workout,
      workoutTitle: "Unknown",
      targets: [],
      punches: [],
      targetsMap: {},
      stats: null,
      averageDelay: null,
      efficiency: null,
    };
  }

  const workoutTitle = getWorkoutTitle(template);
  const targets = template.punchTargets;
  const punchTimestamps = workout.punches.map((punch) => punch.timestamp)
  // console.log("SERVER -> ENRICHED", punchTimestamps)
  const punchForces = workout.punches.map((punch) => punch.force);
  const punchesFull = workout.punches.map((punch) => ({
    ...punch,
    timestamp: punch.timestamp - workout.startTime,
  }));

  const avgForce =
    (punchForces.reduce((a, b) => a + b, 0) / punchForces.length).toFixed(0);


  let heartrateTimestamps = []
  let heartrateBpms = []
  if (workout.heartrate) {
    heartrateTimestamps = unixTimestampsFromStartTime(
      workout.heartrate.map((heartrateMeasurment) => heartrateMeasurment.timestamp),
      workout.startTime
    );
    heartrateBpms = workout.heartrate.map((heartrateMeasurment) => heartrateMeasurment.bpm);
  }

  const targetsMap = mapPunchesToTargets(punchTimestamps, targets);
  const stats = computeStats(targetsMap, targets, punchTimestamps);

  return {
    ...workout,
    template,
    workoutTitle,
    targets,
    punchTimestamps,
    punchForces,
    heartrateTimestamps,
    heartrateBpms,
    punchesFull,
    targetsMap,
    stats,
    avgForce,
    averageDelay: stats ? stats.avgDelay.toFixed(2) : null,
    efficiency: stats ? stats.efficiency.toFixed(0) : null,
  };
};



export function enrichWorkoutNew(workout, template) {
  if (!workout?.punches || !template) {
    return {
      ...workout,
      workoutTitle: "Unknown",
      targets: [],
      punches: [],
      targetsMap: {},
      stats: null,
      averageDelay: null,
      efficiency: null,
    };
  }

  const workoutTitle = getWorkoutTitle(template);
  const targets = template.punchTargets;
  const punchTimestamps = workout.punches.map((punch) => punch.timestamp)
  const punchForces = workout.punches.map((punch) => punch.force);
  const punchesFull = workout.punches.map((punch) => ({
    ...punch,
    timestamp: punch.timestamp - workout.startTime,
  }));

  const avgForce =
    (punchForces.reduce((a, b) => a + b, 0) / punchForces.length).toFixed(0);


  let heartrateTimestamps = []
  let heartrateBpms = []
  if (workout.heartrate) {
    heartrateTimestamps = unixTimestampsFromStartTime(
      workout.heartrate.map((heartrateMeasurment) => heartrateMeasurment.timestamp),
      workout.startTime
    );
    heartrateBpms = workout.heartrate.map((heartrateMeasurment) => heartrateMeasurment.bpm);
  }

  const targetsMap = mapPunchesToTargets(punchTimestamps, targets);
  const stats = computeStats(targetsMap, targets, punchTimestamps);

  return {
    ...workout,
    template,
    workoutTitle,
    targets,
    punchTimestamps,
    punchForces,
    heartrateTimestamps,
    heartrateBpms,
    punchesFull,
    targetsMap,
    stats,
    avgForce,
    averageDelay: stats ? stats.avgDelay.toFixed(2) : null,
    efficiency: stats ? stats.efficiency.toFixed(0) : null,
  };
};


export const createMusicWorkout = async ({
  templateId,
  deviceId,
  userId,
  groupId,
  startTime,
  state = "paused"
}) => {
  if (!templateId || !deviceId || !userId) {
    throw new Error("templateId, deviceId, and userId are required");
  }

  const payload = {
    templateId,
    deviceId,
    userId,
    state
  };

  if (groupId) payload.groupId = groupId;
  if (startTime) payload.startTime = startTime;

  const newWorkoutRecord = await pb.collection("music_workouts").create(payload);

  await Promise.all([
    pb.collection("devices").update(deviceId, {
      currentMusicWorkoutId: newWorkoutRecord.id,
    }),
    pb.collection("users").update(userId, {
      currentMusicWorkoutId: newWorkoutRecord.id,
    }),
  ]);

  return newWorkoutRecord;
};

export const startWorkout = async ({
  workoutId,
  groupId,
  startTime = Date.now(),
}) => {
  if (!workoutId && !groupId) {
    throw new Error("Either workoutId or groupId is required.");
  }

  if (groupId) {
    const group = await pb.collection("workout_groups").getOne(groupId);

    if (group.startTime === 0) {
      await pb.collection("workout_groups").update(groupId, {
        startTime,
        state: "playing"
      });

      const relatedWorkouts = await pb.collection("music_workouts").getFullList({
        filter: `groupId = "${groupId}"`,
      });

      await Promise.all(
        relatedWorkouts.map((workout) =>
          pb.collection("music_workouts").update(workout.id, {
            startTime,
            state: "playing"
          })
        )
      );
    } else {
      await pb.collection("workout_groups").update(groupId, {
        state: "playing"
      });
    }

    return;
  }

  await pb.collection("music_workouts").update(workoutId, {
    startTime,
    state: "playing"
  });
};

export const pauseWorkout = async ({
  workoutId,
  groupId,
  lastPauseTime = Date.now(),
}) => {
  if (!workoutId && !groupId) {
    throw new Error("Either workoutId or groupId is required.");
  }

  if (groupId) {
    await pb.collection("workout_groups").update(groupId, {
      state: "paused",
      lastPauseTime
    });

    const relatedWorkouts = await pb.collection("music_workouts").getFullList({
      filter: `groupId = "${groupId}"`,
    });

    await Promise.all(
      relatedWorkouts.map((workout) =>
        pb.collection("music_workouts").update(workout.id, {
          state: "paused",
          lastPauseTime
        })
      )
    );

    return;
  }

  await pb.collection("music_workouts").update(workoutId, {
    state: "paused",
    lastPauseTime
  });
};

export const resumeWorkout = async ({
  workoutId,
  groupId,
  resumeTime = Date.now(),
}) => {
  if (!workoutId && !groupId) {
    throw new Error("Either workoutId or groupId is required.");
  }

  if (groupId) {
    const group = await pb.collection("workout_groups").getOne(groupId);
    const pauseDuration = group.lastPauseTime ? resumeTime - group.lastPauseTime : 0;
    const newStartTime = group.startTime + pauseDuration;

    await pb.collection("workout_groups").update(groupId, {
      state: "playing",
      startTime: newStartTime,
      lastPauseTime: 0
    });

    const relatedWorkouts = await pb.collection("music_workouts").getFullList({
      filter: `groupId = "${groupId}"`,
    });

    await Promise.all(
      relatedWorkouts.map((workout) => {
        const workoutPauseDuration = workout.lastPauseTime ? resumeTime - workout.lastPauseTime : 0;
        return pb.collection("music_workouts").update(workout.id, {
          state: "playing",
          startTime: workout.startTime + workoutPauseDuration,
          lastPauseTime: 0
        });
      })
    );

    return;
  }

  const workout = await pb.collection("music_workouts").getOne(workoutId);
  const pauseDuration = workout.lastPauseTime ? resumeTime - workout.lastPauseTime : 0;

  await pb.collection("music_workouts").update(workoutId, {
    state: "playing",
    startTime: workout.startTime + pauseDuration,
    lastPauseTime: 0
  });
};

export const finishWorkout = async ({ workoutId, groupId }) => {
  if (!workoutId && !groupId) {
    throw new Error("Either workoutId or groupId is required.");
  }

  const workouts = groupId
    ? await pb.collection("music_workouts").getFullList({
      filter: `groupId = "${groupId}"`,
    })
    : [await pb.collection("music_workouts").getOne(workoutId)];

  await Promise.all(
    workouts.flatMap((workout) => [
      pb.collection("music_workouts").update(workout.id, {
        state: "ended"
      }),
      pb.collection("devices").update(workout.deviceId, {
        currentMusicWorkoutId: "",
      }),
      pb.collection("users").update(workout.userId, { // if this is removed, error doesnt show up
        currentMusicWorkoutId: "",
      }),
    ])
  );

  if (groupId) {
    await pb.collection("workout_groups").update(groupId, {
      state: "ended"
    });
  }
};